// Numeric values are part of the HTTP contract and must remain stable.
export enum LanguageEnum {
  EN = 0,
  ES = 1,
}

export enum RoleEnum {
  POWER_ADMIN = 0,
  STORE_ADMIN = 1,
  POWER_USERS = 2,
  USER = 3,
  USER_NOTIFICATION = 4,
  PARTNER = 5,
  REPORT_USER = 6,
}

export enum SortDirectionEnum {
  ASC = 0,
  DESC = 1,
}
